import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const ComissionsPage = lazy(() => import('./pages/ComissionsPage'))
const TipsPage = lazy(() => import('./pages/TipsPage'))
const FinanceSummary = lazy(() => import('./pages/financeSummary'))
const SalesLogPage = lazy(() => import('./pages/salesLogPage'))
const PerformancePage = lazy(() => import('./pages/performancePage'))

// Load translations immediately when this module is imported

export const reportRoutes = () => {
  return (
    <>
      <Route path={pageUrl.reportComissions} element={<ComissionsPage />} />
      <Route path={pageUrl.reportTips} element={<TipsPage />} />
      <Route path={pageUrl.financeSummary} element={<FinanceSummary />} />
      <Route path={pageUrl.salesLog} element={<SalesLogPage />} />
      <Route path={pageUrl.reportPerformance} element={<PerformancePage />} />
    </>
  )
}
